// src/api/stockApi.js
import apiClient from './axios';

const stockApi = {
  getAll: async (page = 1, pageSize = 10, search = '') => {
    const response = await apiClient.get('/stocks/', {
      params: {
        page,
        page_size: pageSize,
        search: search.trim() || undefined, // Only send if not empty
      },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },
};

export default stockApi;